<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-modal v-model="isVisible">
        <div
          slot="header"
          class="custom-header"
        >
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                Vehicle
              </h4>
            </div>
            <div class="col-md-1">
              <a
                href="#"
                @click="close"
                class="custom-close"
              >
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div slot="body">
          <div class="row">
            <contact-vehicle :value="contact" />
          </div>
        </div>
        <div
          slot="footer"
          class="custom-footer"
        >
          <div class="col-md-6">
            <span>{{ parent }}</span>
          </div>
          <div class="col-md-6">
            <div class="custom-footer-buttons">
              <button
                class="btn btn-light"
                @click="close"
              >Cancel</button>
              <button
                type="submit"
                class="btn btn-primary"
              >Save</button>
            </div>
          </div>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import ContactVehicle from '@/components/contacts/forms/vehicle'
export default {
  name: 'vehicle-dialog',
  components: {
    DtModal,
    ContactVehicle
  },
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      message: ''
    }
  },
  computed: {
    ...mapGetters('contacts', ['contact']),
    ...mapGetters('vehicles', ['vehicle']),
    parent: {
      get() {
        let _id = null
        console.log('Contact in Vehicle Dialog', this.vehicle)
        if (this.vehicle !== undefined && this.vehicle !== null) {
          _id = 'id: #' + this.vehicle.vehicle
        }
        return _id
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions('vehicles', ['saveVehicle']),
    close() {
      this.$emit('closing')
    },
    async submit() {
      this.message = ''
      this.$refs.form.validate().then(async success => {
        if (success) {
          let data = {
            vehicle: this.vehicle.vehicle,
            contact: this.vehicle.contact,
            firm: this.vehicle.firm,
            make: this.vehicle.make,
            model: this.vehicle.model,
            vin: this.vehicle.vin,
            year: this.vehicle.year
          }
          console.log('saving Vehicle', data)
          await this.saveVehicle(data)
          this.$emit('saved')
        } else {
          this.message = 'Please fill in all fields.'
        }
        this.$emit('send')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-textarea {
  height: 200px;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-footer-buttons {
  position: relative;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/vehicle-dialog.vue